import { render, staticRenderFns } from "./paySettingFrom.vue?vue&type=template&id=bb3d01c0&scoped=true&"
import script from "./paySettingFrom.vue?vue&type=script&lang=js&"
export * from "./paySettingFrom.vue?vue&type=script&lang=js&"
import style0 from "./paySettingFrom.vue?vue&type=style&index=0&id=bb3d01c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3d01c0",
  null
  
)

export default component.exports